import { FaIdCardAlt, FaMobileAlt, FaMoneyBill, FaUser } from "react-icons/fa";
import { BsFileEarmarkTextFill } from "react-icons/bs";
import { IoIosWallet } from "react-icons/io";
import { BsFillGridFill } from "react-icons/bs";
import { BsFolderSymlinkFill } from "react-icons/bs";
import { BsFillFilterCircleFill } from "react-icons/bs";
import { TbReportMoney } from "react-icons/tb";
import { FaMoneyCheckDollar } from "react-icons/fa6";

import { PrivatePaths } from "../../routes/path";

export const userLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: "Dashboard",
    Icon: BsFillGridFill,
    allowed: ["User"],
  },

  {
    route: "#",
    name: "Users",
    Icon: FaUser,
    allowed: ["User"],
    children: [
      {
        route: "/app/account",
        name: "Accounts",
        Icon: FaUser,
        allowed: ["User"],
      },
      // {
      //   route: "/app/manage/kyc",
      //   name: "Manage KYC",
      //   Icon: FaIdCardAlt,
      //   allowed: ["User"],
      // },
    ],
  },
  {
    route: "/app/savings",
    name: "Savings",
    Icon: IoIosWallet,
    allowed: ["User"],
    children: [
      {
        route: "/app/config/savings",
        name: "Savings Type",
        Icon: FaIdCardAlt,
        allowed: ["User"],
      },
      {
        route: "/app/savings",
        name: "Savings",
        Icon: IoIosWallet,
        allowed: ["User"],
      },
    ],
  },
  {
    route: "#",
    name: "Investments Area",
    Icon: TbReportMoney,
    allowed: ["User"],
    children: [
      {
        route: "/app/investments/sections",
        name: "Investments",
        Icon: TbReportMoney,
        allowed: ["User"],
      },
    ],
  },
  {
    route: "#",
    name: "Support",
    Icon: FaMoneyBill,
    allowed: ["User"],
    children: [
      {
        route: "/app/funding",
        name: "Funding",
        Icon: FaMoneyBill,
        allowed: ["User"],
      },
    ],
  },

  {
    route: "#",
    name: "TRANSACTIONS",
    Icon: FaIdCardAlt,
    allowed: ["User"],
    children: [
      {
        route: "/app/transactions/history",
        name: "Transaction History",
        Icon: BsFolderSymlinkFill,
        allowed: ["User"],
      },
      {
        route: "/app/transactions/withdrawal",
        name: "Withdrawal Request",
        Icon: BsFolderSymlinkFill,
        allowed: ["User"],
      },
    ],
  },
  {
    route: "#",
    name: "CONFIGURATIONS",
    Icon: FaIdCardAlt,
    allowed: ["User"],
    children: [
      {
        route: "/app/config/admin",
        name: "Admin",
        Icon: FaIdCardAlt,
        allowed: ["User"],
      },
      {
        route: "/app/config/app-version",
        name: "App Version",
        Icon: FaMobileAlt,
        allowed: ["User"],
      },
    ],
  },
  {
    route: "#",
    name: "REPORTS",
    Icon: FaIdCardAlt,
    allowed: ["User"],
    children: [
      {
        route: "/app/activity/report",
        name: "User Activity",
        Icon: FaIdCardAlt,
        allowed: ["User"],
      },
      // {
      //   route: "/app/driver",
      //   name: "Reports Section",
      //   Icon: FaIdCardAlt,
      //   allowed: ["User"],
      // },
    ],
  },
];
